import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as UserStore from '../../app/store/UserStore';

const activityProps = ['patientId', 'patientProgramId', 'patientProgramElementId', 'taskId', 'moduleId'];

class TrackActivity extends React.Component {
    componentDidMount() {
        this.sendActivity();
    }

    componentDidUpdate(prevProps) {
        if (activityProps.reduce((prev, curr) => prev || this.props[curr] !== prevProps[curr], false)) {
            this.sendActivity(prevProps.activityId);
        }
    }

    componentWillUnmount() {
        this.endActivity(this.props.activityId);

        // To end last activity when i.e. navigating away (or refreshing  page) we should detext unload, but
        // this is not working. Request is canceled by browser on navigating away
        // window.addEventListener('beforeunload', this.sendActivity);
        // window.removeEventListener('beforeunload', this.sendActivity);
    }

    sendActivity = (endId) => {
        if (this.props.patientId) {
            this.props.sendActivity({
                endId,
                pid: this.props.patientId,
                ppid: this.props.patientProgramId,
                ppeid: this.props.patientProgramElementId,
                tid: this.props.taskId,
                mid: this.props.moduleId,
                l: this.props.label,
                start: new Date(),
            });
        }
    }

    endActivity = (endId) => {
        if (this.props.patientId) {
            this.props.sendActivity({
                endId,
                pid: this.props.patientId,
                start: new Date(),
            });
        }
    }

    render() {
        return null;
    }
}

TrackActivity.propTypes = {
    sendActivity: PropTypes.func.isRequired,
    activityId: PropTypes.number,
    label: PropTypes.string.isRequired,
    patientId: PropTypes.string,
    patientProgramId: PropTypes.string,
    patientProgramElementId: PropTypes.string,
    taskId: PropTypes.string,
    moduleId: PropTypes.string,
};

TrackActivity.defaultProps = {
    patientId: null,
    activityId: null,
    patientProgramId: null,
    patientProgramElementId: null,
    taskId: null,
    moduleId: null,
};

const mapStateToProps = state => ({
    patientId: state.auth.profileData && state.auth.profileData.id,
    activityId: state.user.activityId,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(UserStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrackActivity);
